import { StoreRegistry } from '../store';
import {
  getCartItemData,
  getCartItemsList,
  ProductItemId
} from '../store/cart';

export const getCart = () =>
  getCartItemsList(StoreRegistry.instance.store.getState());

export const getCartItem = (id: ProductItemId) =>
  getCartItemData(id)(
    StoreRegistry.instance.store.getState()
  );
